// extracted by mini-css-extract-plugin
export var actionText = "_pj-4";
export var container = "_pj-0";
export var leftSection = "_pj-1";
export var rightSection = "_pj-2";
export var settingsButton = "_pj-6";
export var settingsIcon = "_pj-7";
export var shortcut = "_pj-5";
export var shortcutGroup = "_pj-3";